import { FirstFoldHeroCardData } from '../types';

// FirstFold Hero Cards Data
export const FIRST_FOLD_HERO_CARDS: FirstFoldHeroCardData[] = [
  {
    href: 'https://cleartax.in/filing?utm_ref=cleartax_homepage_herofold',
    trackingLabel: 'hero_cta-newSelf ITR Filing',
    hoverText: 'Seamless filing powered by AI',
    hoverId: 'hover-purple-div-1',
    backgroundGradient:
      'linear-gradient(135.63deg, #fff7dd -0.03%, #ffffff 34.41%)',
    iconSrc:
      'https://assets.clear.in/cleartax/images/1751894073_group1814224095.svg',
    iconAlt: 'Self ITR filing',
    title: 'Self ITR filing',
    subtitle: '100% accuracy',
    buttonText: 'File Now',
  },
  {
    href: 'https://cleartax.in/s/pricing?utm_ref=cleartax_homepage_herofold',
    trackingLabel: 'hero_cta-newHire an Expert',
    hoverText: 'India\u2019s Top Tax Experts',
    hoverId: 'hover-purple-div-2',
    backgroundGradient:
      'linear-gradient(135.63deg, #fbedeb 2.99%, #ffffff 34.41%)',
    iconSrc:
      'https://assets.clear.in/cleartax/images/1751960822_group1814224094.svg',
    iconAlt: 'Hire an expert',
    title: 'Hire an expert',
    subtitle: 'ITR filed in 24 hours',
    buttonText: 'Book Now',
  },
];

// Hero Section Constants
const HERO_SECTION_CONSTANTS = {
  heading_h1: 'Income Tax e Filing',
  refundAmount: 418.26,
  platformText: 'We are now live for ITR filing on',
  platformLogos: [
    {
      src: 'https://assets.clear.in/cleartax/images/1751959705_image517.svg',
      alt: 'teams',
    },
    {
      src: 'https://cleartax-media.s3.amazonaws.com/cleartax/images/1755862072_waitrhp.webp',
      alt: 'whatsapp',
    },
    {
      src: 'https://assets.clear.in/cleartax/images/1751959858_image518.svg',
      alt: 'slack',
    },
  ],

  statistics: [
    {
      value: '★4.9/5',
      label: '45K+ Reviews ',
    },
    {
      value: '₹5,346 Cr+',
      label: 'Refunds delivered last year',
    },
    {
      value: '7.5 M+',
      label: 'Users Trust Us',
    },
  ],
};

// FirstFold Constants (reusing common data from HERO_SECTION_CONSTANTS)
export const FIRST_FOLD_CONSTANTS = {
  refundAmount: HERO_SECTION_CONSTANTS.refundAmount,
  platformText: HERO_SECTION_CONSTANTS.platformText,
  platformLogos: HERO_SECTION_CONSTANTS.platformLogos,
  statistics: HERO_SECTION_CONSTANTS.statistics,
};

// Refund Amount Constant
export const REFUND_AMOUNT = 418.26;
